module.exports = __webpack_public_path__ + "img/picture-placeholder-medium-gray.abbdcc00.png";